export default "__VITE_ASSET__olLaxhh6__"